type SupportedLanguage = {
  text: string;
  value: string;
  enName?: string;
};

export const sortLanguage = (
  supportedLanguages: Array<SupportedLanguage>,
  providerLanguage: string = 'en-US',
) => {
  const newSortedLanguages = [...supportedLanguages];
  const lang = newSortedLanguages.find(lang => lang.value === providerLanguage);
  const index = newSortedLanguages.map(lang => lang.value).indexOf(providerLanguage);
  newSortedLanguages.splice(index, 1);
  const langSelected = lang ? lang : { text: '-', value: '' };
  newSortedLanguages.splice(0, 0, langSelected);
  return newSortedLanguages;
};
